<template>
  <div class="composite-did-you-know-card" :class="{ 'vertical-layout': vertical }">
    <div class="img-container">
      <img :src="img" />
    </div>
    <div class="content">
      <CommonTitleUnderline :title="title" :gray="gray" />
      <p class="description" :class="{ gray: gray }">
        {{ description }}
      </p>
    </div>
  </div>
</template>

<script lang="ts" setup>
import CommonTitleUnderline from '../common/CommonTitleUnderline.vue'

withDefaults(
  defineProps<{
    title: string
    img: string
    description: string
    gray?: boolean
    vertical?: boolean
  }>(),
  {
    gray: false,
  },
)
</script>

<style lang="scss" scoped>
.composite-did-you-know-card {
  display: flex;
  gap: var(--spacer-0_5);

  &.vertical-layout {
    flex-direction: column-reverse;
    justify-content: start;
    max-width: 100%;

    .img-container {
      height: 100%;
      border-radius: 60px;
    }
  }

  .img-container {
    display: flex;
    align-self: stretch;
    border-top-left-radius: var(--br-big);
    border-bottom-left-radius: var(--br-big);
    overflow: hidden;
    min-width: 200px;

    img {
      height: 100%;
      width: 100%;
      object-fit: cover;
    }
  }

  .title,
  .description {
    color: var(--vc-primary);

    &.gray {
      color: var(--vc-gray4);
    }
  }

  .title {
    font-size: 26px;
    text-transform: uppercase;
    line-height: 1;
    text-decoration: underline dotted;
    text-underline-offset: 10px;
    margin-bottom: var(--spacer);
  }
}
</style>
